import { AnsweredQuestionWithId } from "../model";

export const checkExistenceOfQuestionWithId = (questions: AnsweredQuestionWithId[], questionId: string) => {
    return questions.some(question => question.id === questionId);
};
